import { ChatBubbleOvalLeftEllipsisIcon, ClipboardDocumentCheckIcon } from "@heroicons/react/24/outline";
import { BookOpen, UsersRound } from "lucide-react";

export const baseUrl = import.meta.env.VITE_APP_URL;
export const dashboardUrl = import.meta.env.VITE_DASHBOARD_URL;
export const apiUrl = `${baseUrl}api/`;
export const appVersion = `0.0.1`;
export const imageUrl = `https://loremflickr.com/`;
export const isLocal = process.env.NODE_ENV !== 'production';
export const imgThumb = import.meta.env.VITE_APP_THUMBNAIL;
export const imgLarge = import.meta.env.VITE_APP_LARGE;
export const fileUrl = import.meta.env.VITE_APP_FILE_LINK;
export const xApiKey = import.meta.env.VITE_X_API_KEY;
export const loginURL = import.meta.env.VITE_LOGIN_URL;
export const registerURL = import.meta.env.VITE_REGISTER_URL;
export const crispID = import.meta.env.VITE_CRISP_WEBSITE_ID;
export const toEn = (s: any) =>
    s.replace(/[\u0660-\u0669\u06f0-\u06f9]/g, (a: any) => a.charCodeAt(0) & 15);
export const whatsappUrl = (phone: string | number, message?: string) => `https://api.whatsapp.com/send?phone=${phone}&${message ? `text=${message}` : ``}`;

export const getImage = (name?: string) => {
    return `/images/${name}`;
};

export const getThumb = (name?: string) => {
    return `/${imgThumb}${name}`;
};

export const getLarge = (name?: string) => {
    return `/${imgLarge}${name}`;
};

export const getFile = (name?: string) => {
    return `${fileUrl}${name}`;
};

export const getIcon = (name?: string) => {
    return `/icons/ui/${name}`;
};

export function classNames(...classes: any) {
    return classes.filter(Boolean).join(" ");
}

export const compareSections: any = [
    {
        name: "Features",
        features: [
            {
                name: " Full Cambridge Curriculum ",
                tiers: { "1": false, "2": "english", "3": "English, Math, Science", "4": true, "5": false },
            },
            {
                name: " Live online classeses",
                tiers: { "1": false, "2": false, "3": true, "4": true, '5': false },
            },
            {
                name: " Recorded Classes with Certified Teachers",
                tiers: {
                    "1": true,
                    "2": true,
                    "3": true,
                    "4": true,
                    '5': true,
                },
            },
            {
                name: "Group & 1-1 Session",
                tiers: { "1": false, "2": false, "3": false, "4": "(4 hours/month)", '5': false },
            },
            {
                name: "Personalised learning plan",
                tiers: { "1": false, "2": false, "3": false, "4": true, '5': false },
            },
            {
                name: "Standard Learning Plan",
                tiers: { "1": false, "2": false, "3": false, "4": false, '5': true },
            },
            {
                name: "Assignments, Quizzes, Progress tracking",
                tiers: { "1": true, "2": true, "3": true, "4": true, '5': true },
            },
            {
                name: "Full Access to Skills Courses",
                tiers: { "1": false, "2": false, "3": false, "4": true, '5': true },
            },
            {
                name: "Full Access to Metaverse Campus",
                tiers: { "1": false, "2": false, "3": false, "4": true, '5': false },
            },
            {
                name: "Exam Admin Support",
                tiers: { "1": false, "2": false, "3": false, "4": true, '5': false },
            },
            {
                name: "Parental Points Programme",
                tiers: { "1": false, "2": false, "3": false, "4": true, "5": false },
            },
            {
                name: "Scholarship Eligibility",
                tiers: { "1": false, "2": false, "3": false, "4": true, '5': false },
            },
            {
                name: "Limited AI-driven Learning Resources",
                tiers: { "1": false, "2": false, "3": false, "4": false, '5': true },
            },
            {
                name: "24/7 Live Chat Support",
                tiers: { "1": false, "2": true, "3": true, "4": true, "5": true },
            },
        ],
    },
];


export const otherFeatures = [
    {
        name: "Full Cambridge Education, Anytime, Anywhere",
        description:
            "Experience a world-class education online with a full Cambridge curriculum, delivered to suit your learning preferences, requirements and schedule.",
        icon: BookOpen,
        href: route("frontend.{slug}.index", { slug: "courses" }),
    },
    {
        name: "Expert Teachers",
        description:
            "Access one-on-one or group sessions with highly qualified educators who personalise lessons to fit your schedule and learning needs.",
        icon: UsersRound,
        href: route("frontend.{slug}.index", { slug: "teaching" }),
    },
    {
        name: "AI-Powered Diagnostics",
        description:
            "Our advanced diagnostics assess both academic strengths and areas for improvement, providing a tailored learning path for every student.",
        icon: ClipboardDocumentCheckIcon,
        href: route("frontend.{slug}.index", { slug: "diagnostics" }),
    },
    {
        name: "Real-Time Feedback",
        description:
            "Get instant feedback from live sessions, along with detailed progress reports, ensuring continuous improvement and success in your studies.",
        icon: ChatBubbleOvalLeftEllipsisIcon,
        href: route("frontend.{slug}.index", { slug: "diagnostics" }),
    },
];
